import styled from "styled-components";

export const BillingSelect = styled.select`
    border: 1px solid #CECEDC;
    height: 48px;
    padding: 5px 10px;
    margin-bottom: 12px;
    width: calc(50% - 10px);
    float: left;
    margin-left: 10px;
    font-size: 20px;
`;

export const PlanPriceSuperscript = styled.span`
    color: #A4A6B9;
    font-size: 18px;
    position: relative;
    top: -15px;
    left: -4px;
`;


export const BillingInputSmall = styled.input`
    border: 1px solid #CECEDC;
    height: 48px;
    padding: 5px 10px;
    margin-bottom: 12px;
    width: 50%;
    float: left;
    font-size: 20px;
`;

export const CallListNote = styled.p`
    font-size: 16px;
    color: #888888;

    a {
        color: #5562C0;
        margin-left: 5px;
    }
`;

export const CallListUser = styled.div`
    padding: 6px 12px;
    color: #515151;

    &:hover {
        background: #D8D8D8;
    }

    .call-list-initials {
        display: inline-block;
        width: 32px;
        height: 32px;
        border-radius: 100%;
        background: grey;
        color: white;
        font-size: 12px;
        text-align: center;
        margin-right: 12px;
        padding-top: 7px;
        position: relative;
    }

    .call-list-name {
        display: inline-block;
        font-size: 18px;
        width: 232px;
        padding-right: 10px;
        color: #515151;
    }

    .call-list-actions {

    }

    .call-list-action {
        margin-right: 12px;
        cursor: pointer;
        color: #515151;

        &.purple {
            color: #5562C0;
        }

        &.toggled {
            color: #ED6D5F;

            .fa-microphone-slash {
                margin-left: -7px;
                right: -1px;
                position: relative;
            }
        }
    }
`;
